import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

import OilTypeSelect from '../OilTypes/OilTypeSelect';

class OilOrder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      oilOrder: JSON.parse(JSON.stringify(this.props.oilOrder)),
    };

    this.handleOilTypeChange = this.handleOilTypeChange.bind(this);
    this.handleQuantityChange = this.handleQuantityChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.oilOrder) {
      this.setState({ oilOrder: JSON.parse(JSON.stringify(nextProps.oilOrder)) });
    }
  }

  clearOrder() {
    // const oilOrder = JSON.parse(JSON.stringify(this.state.oilOrder));
    let oilOrder = this.state.oilOrder;
    oilOrder = {};
    this.setState({ oilOrder }, ()=>{
      console.log(this.state.oilOrder)
      this.formChange();
    });
  }

  formChange() {
    this.props.onFormChange(this.state.oilOrder);
  }

  handleQuantityChange(inputValue) {
    const oilOrder = this.state.oilOrder;
    oilOrder.quantity = inputValue.target.value;

    this.setState({ oilOrder }, this.formChange());
  }

  handleOilTypeChange(value) {
    const oilOrder = this.state.oilOrder;
    oilOrder.oilTypeId = value;

    if (oilOrder.oilTypeId) {
      this.setState({ oilOrder }, this.formChange());
    } else {
      this.clearOrder();
    }
  }

  renderOrderForm() {
    return (
      <label>
      Quantity<br />
        <input
          id="location"
          type="number"
          className="oilQuantityInput"
          placeholder="0"
          value={this.state.oilOrder.quantity}
          onChange={this.handleQuantityChange}
          onKeyDown={this.handleSubmitOnEnter} />
          <span className="quantityMetric">Quarts</span>
      </label>
    )
  }

  render() {
    const quantityClass = this.state.oilOrder.oilTypeId ? 'hasQuantity' : '';
    return (
      <span className={`oilOrder ${quantityClass}`}>
        <label className="oilTypeSelection">
          Oil Type<br />
          <OilTypeSelect onSelectChange={this.handleOilTypeChange} selectedValue={this.state.oilOrder.oilTypeId} fboId={this.props.fboId} />
        </label>
        <div className="oilQuantity">
        {this.state.oilOrder.oilTypeId &&
          this.renderOrderForm()
        }
        </div>
        <div className="clear"></div>
      </span>
    );
  }
}

OilOrder.propTypes = {
  onFormChange: PropTypes.func.isRequired,
  fboId: PropTypes.number.isRequired,
  oilOrder: PropTypes.shape({
    oilTypeId: PropTypes.number.isRequired,
  }).isRequired,
};

export default OilOrder;



// WEBPACK FOOTER //
// ./src/Containers/Orders/OilOrder.js